var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('contentRender',{staticClass:"dynamic-text",class:_vm.limitLines && 'limit-lines',attrs:{"content":_vm.content || '&nbsp;'}})}
var staticRenderFns = []

export { render, staticRenderFns }